import {getWindowWidth, throttle} from '../util/helperFunctions';

const body = document.body;
const siteNavbarCollapse = document.getElementById('navigation');
const siteNavbarToggler = document.querySelector('.navbar-toggler-alternative');

let scrollDistance = 0;
let scrollDistanceStart = 0;
let scrollDistanceSaved = false;

// Scroll
const handleScroll = () => {
	if (window.scrollY > 0) {
		body.classList.add('is-scrolling');
	} else {
		body.classList.remove('is-scrolling');
	}
};

window.addEventListener('scroll', throttle(handleScroll, 100));

// Navigation collapse
if (siteNavbarCollapse) {
	siteNavbarCollapse.addEventListener('show.bs.collapse', () => {
		body.classList.add('site-header-toggled-show');
	});

	siteNavbarCollapse.addEventListener('hidden.bs.collapse', () => {
		body.classList.remove('site-header-toggled-show');
	});
}

// Close nav on click outside of '.sitenav-collapse-inner'
const navbarAutoClose = (e) => {
	const target = e.target;

	if (
		target.matches('.site-header') ||
		(target.closest('.site-header') &&
			target.closest('.site-header').classList.contains('site-header')) ||
		target.classList.contains('navbar-toggler') ||
		target.classList.contains('navbar-toggler-alternative')
	) {
		return;
	}

	if (
		siteNavbarToggler.hasAttribute('aria-expanded') &&
		siteNavbarToggler.getAttribute('aria-expanded') === 'true'
	) {
		siteNavbarToggler.click();
	}
};

document.addEventListener('click', navbarAutoClose);
document.addEventListener('touchstart', navbarAutoClose);

// Resize
let resizing;

window.addEventListener('resize', () => {
	clearTimeout(resizing);

	resizing = setTimeout(() => {
		if (getWindowWidth() >= 992) {
			if (
				siteNavbarToggler.hasAttribute('aria-expanded') &&
				siteNavbarToggler.getAttribute('aria-expanded') === 'true'
			) {
				body.classList.remove('site-header-toggled-show');
				siteNavbarCollapse.classList.remove('show');
				siteNavbarToggler.setAttribute('aria-expanded', 'false');
			}
		} else {
			scrollDistance = 0;
			scrollDistanceStart = 0;
			scrollDistanceSaved = false;
			body.classList.remove('is-header-hidden');
		}
	}, 100);
});
